import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { BehaviorSubject, Subject, forkJoin, Observable, combineLatest, zip } from 'rxjs'
import { concatMap, startWith, take } from 'rxjs/operators'
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ClaimClientRole,
  InteractService,
  IntimationService,
  ClaimRegistrationService,
  CommonUtilty,
  AppMetadataHandler,
  WorkqueueService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ComponentOutputDO, IntimationIO } from 'app/BaseFramework/shared/models';
import { json } from 'ngx-custom-validators/src/app/json/validator';
import * as moment from 'moment/moment';
import configData from './transaction-details.component.json';
//import { default as rulesDataObj } from './sample_rules.json';
import { environment } from 'environments/environment';
import { ClientList } from 'app/ViewModules/shared-components/captured-client-list/captured-client-list.component.js';

export class TaskIO {
  taskCd: any;
  entityGuid: any;
  objectName: any
  assignedto: any
}
@Component({
  selector: 'app-transaction-proposal-details',
  templateUrl: './transaction-proposal-details.component.html',
  styleUrls: ['./transaction-proposal-details.component.scss']
})
export class TransactionProposalDetailsComponent implements OnInit {

  constructor(
    private message: NzMessageService,
    private modalService: NzModalService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private validationUtilService: ValidationUtilService,
    private interactService: InteractService,
    private intimationService: IntimationService,
    private claimRegistrationService: ClaimRegistrationService,
    private commonUtilty: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    private workqueueService: WorkqueueService,
  ) {
    /* Set State (If passed from other routes. Eg: New-Intimation) */
    let newState = this.route.snapshot.paramMap.get('from');
    // if (newState) this.state = newState;
    // console.log("[state] -- ", this.state);
    this.nullifyPayloadInEdit = 'start'
  }

  transactionForm = this.fb.group({})
  tempJosn: any;
  nomineeClaimantFlag: any = false;
  lookupsToBind = ['roleUsers', 'csrUsersUID', 'claimRegRoleUsers']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  assigneeUser: any = null
  dummyJsonIntimation = configData.dummyJsonIntimation
  TRUEVALUE = true;
  FALSEVALUE = false
  state
  enableModalClose


  public transactionMasterUpdateControl = true;
  private _payloadInEdit = null
  set payloadInEdit(value: any) {
    if (this._payloadInEdit == null) {
      this._payloadInEdit = this.commonUtilty.deepCopy(value)
    }
    else {
      throw "You cannot set payloadInEdit, since it's a constant and can be initialized only once"
    }
  }

  get payloadInEdit() {
    return this._payloadInEdit
  }

  set nullifyPayloadInEdit(value: any) {
    this._payloadInEdit = null
  }


  mapperTransactionState = null
  TransactionState = null;
  inboxType = null;
  taskId = null;

  initializeIntimationTabs() {
    this.transactionForm = this.fb.group({
    });
  }

  setFooter(data) {
    this.ClientCaptureFooter = data
  }

  enableTabFor(states) {
    let c = states.includes(this.mapperTransactionState)
    return c
  }

  disableTabFor(states) {
    let c = states.includes(this.mapperTransactionState)
    return !c
  }

  tabStates = this.commonUtilty.deepCopy(configData.tabStates)

  getTabVisibilityStatus(tabKey) {
    let tabKeyMetaData = this.tabStates[tabKey]
    if (tabKeyMetaData.enableTab) {
      return this.enableTabFor(tabKeyMetaData.states)
    }
    else {
      return this.disableTabFor(tabKeyMetaData.states)
    }
  }

  trasactionPageDataStateMap = {
    claimIntimation: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject()
      }
    },
    claimRegistration: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
      }
    },
    claimAdjudication: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ClaimDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject() //Transform Breaking with error 500
      }
    },
    claimInvestigation: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
      }
    },
    claimPayout: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
      }
    },
    claimUWReferral: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ClaimDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject()
      }
    },
    claimReinsReferral: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ClaimDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject()
      }
    }
  }

  trasactionChildComponentTabPlacementMap = {
    ClaimsBasicDetailsComponent: 0,
    CapturedPolicyListComponent: 0,
    CapturedClientListComponentNOMINEE: 2,
    CapturedClientListComponentCLAIMANT: 2,
    InsuredDetailsComponent: 1,
    ClaimDecisionComponent: 6,
  }

  attemptForTransaction(transactionSaveType) {
    this.interactService.transactionCloserState(transactionSaveType)
    this.askAllChildrenForData()
  }

  askAllChildrenForData() {
    this.interactService.pingChildToReact(this.route.routeConfig.component.name)
  }

  getChildrenSubscriberDataPipe() {
    let childrenSubscribers$ = []
    if (this.mapperTransactionState) {
      let components = this.trasactionPageDataStateMap[this.mapperTransactionState].components
      components['MulticaptureBankDetailsComponent'] = new Subject()
      for (const key in components) {
        if (components.hasOwnProperty(key)) {
          childrenSubscribers$.push(components[key]);
        }
      }
    }

    if (childrenSubscribers$.length == Object.keys(this.trasactionPageDataStateMap[this.mapperTransactionState].components).length)
      return childrenSubscribers$
    else
      throw new Error("Number of Subject Mappers Do not Match Number of childrenSubscribers")
  }

  getChildrenNumber() {
    let count = null
    if (this.trasactionPageDataStateMap &&
      this.trasactionPageDataStateMap[this.mapperTransactionState] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components']
    ) {
      let c = Object.keys(this.trasactionPageDataStateMap[this.mapperTransactionState]['components'])
      count = c.length
    }

    console.log("count", count)
    return count
  }

  childrenDataPipeSubscription$
  initializeChildSubscribers() {
    let childrenDataPipe = this.getChildrenSubscriberDataPipe()
    if (childrenDataPipe.length === this.getChildrenNumber()) {
      if (this.childrenDataPipeSubscription$ != null) this.childrenDataPipeSubscription$.unsubscribe()
      this.childrenDataPipeSubscription$ = zip(...childrenDataPipe).subscribe(responses => {

        console.log((Object.keys(this.emitterHistory).length + " count of object"));
        if (Object.keys(this.emitterHistory).length === this.getChildrenNumber())
          this._intimationTransformUItoServer(responses)
        else {
          if (!environment.production) {
            throw "Missing Subject for a component that's emitting data. Check transactionPageDataStateMap or _BaseEmitterHandler.";

          }
        }
      })
    }
    else {
      throw "Component Emitters Mismatch";

    }
  }

  emitterHistory = {}
  _BaseEmitHandler(data, componentName) {
    console.log("BaseEmitHandler Fired For " + componentName)
    this.emitterHistory[componentName] = data
    if (this.trasactionPageDataStateMap &&
      this.trasactionPageDataStateMap[this.mapperTransactionState] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName]
    ) {
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName].next(data);
    }
    else {
      console.warn(`A Component - ${componentName} emitted data but as per Data Pipeline is not valid for serviceTask ${this.mapperTransactionState}`)
    }
    if (Object.keys(this.emitterHistory).length === this.getChildrenNumber()) {
      console.log("All Childrem emitted data")
      console.log(this.emitterHistory)
    }
  }

  getBasicDetails(data) {
    console.log(data)
  }

  _transactionInProgress = false
  _UIErrorList = []
  _intimationTransformUItoServer(responses) {
    let ErrorList = []
    this._transactionInProgress = true
    let payload = null
    if (responses != null && !responses) {
      if (this.payloadInEdit != null) {
        payload = this.payloadInEdit // Editmode
      }
      else {
        payload = new IntimationIO()
        payload = this._setSubmissionModeFromUI(payload)
      }
      responses.forEach((response: any) => {
        if (response.componentName === 'ClaimsBasicDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimsBasicDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimsBasicDetailsComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'CapturedPolicyListComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._CapturedPolicyListComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._CapturedPolicyListComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'CapturedClientListComponent' || response.componentName === 'InsuredDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (response.componentData && !!!response.componentData.isInvalid)
              payload = this._CapturedClientListComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._CapturedClientListComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'DocumentManagerComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._DocumentManagerComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._DocumentManagerComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ClaimDecisionComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimDecisionComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimDecisionComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ClaimsBenefitComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimsBenefitComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimsBenefitComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'MulticaptureBankDetailsComponent' || response.componentName === 'ClaimsPaymentBreakupComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._MulticaptureBankDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._MulticaptureBankDetailsComponentToSeverDOMapper(payload, response)
          }
        }

      });
    }
    if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform && ErrorList) {
      this._UIErrorList = this.commonUtilty.deepCopy(ErrorList)
    }
    if (payload != null && Array.isArray(this._UIErrorList) && this._UIErrorList.length == 0) {
      if (this.appMetadataHandler.featureFlags.enableMarkAllRequirementsAsReceived)
        payload = this.___markAllRequirementsAsReceived(payload)
      if (this.appMetadataHandler.featureFlags.enableMarkAllChecklistAsCompleted)
        payload = this.___markAllChecklistAsCompleted(payload)

      console.log("TransactionState " + this.TransactionState);
      if (this.TransactionState === 'claimIntimation')
        this._saveOrSubmitIntimationTransaction(payload);

      //TODO check with ganesh and ninad

      if (this.TransactionState == 'claimAdjudication')
        this._saveOrSubmitAdjudicationTransaction(payload);
      else if (this.TransactionState !== 'claimIntimation' && this.TransactionState !== 'claimInvestigation')
        this._saveOrSubmitRegistrationTransaction(payload);
    }
    else if (!environment.production) {
      // throw new Error("Unexpected Error - Empty Payload")
    }


  }

  private _saveOrSubmitIntimationTransaction(payload: any) {
    if (payload) {

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveIntimation(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitIntimation(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }

  saveIntimation$ = null
  saveIntimation(payload) {
    if (this.saveIntimation$) this.saveIntimation$.unsubscribe()
    this.saveIntimation$ = this.intimationService.saveIntimation(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }
  submitIntimation$ = null
  submitIntimation(payload) {
    if (this.submitIntimation$) this.submitIntimation$.unsubscribe()
    this.submitIntimation$ = this.intimationService.submitIntimation(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }
  saveRegistrationObservable = null
  private _saveOrSubmitRegistrationTransaction(payload: any) {
    if (payload) {
      if (this.saveRegistrationObservable)
        this.saveRegistrationObservable.unsubscribe();
      this.message.loading('Saving', { nzDuration: 4000 });
      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveRegistration(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitRegistration(payload);
          }
        })


    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }




  private _saveOrSubmitAdjudicationTransaction(payload: any) {

    if (payload) {
      if (this.saveRegistrationObservable)
        this.saveRegistrationObservable.unsubscribe();

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveAdjudication(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitAdjudication(payload);
          }
        })


    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }
  saveRegistration(payload) {
    this.claimRegistrationService.saveClaimRegistration(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitRegistration(payload) {
    this.claimRegistrationService.submitClaimRegistration(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }

  saveAdjudication(payload) {
    this.claimRegistrationService.saveAdjudication(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitAdjudication(payload) {
    this.claimRegistrationService.submitAdjudition(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }

  private _postSaveHandler(resp: any) {
    this._transactionInProgress = false
    console.log(JSON.stringify(resp))

    let DOName = this._getDOName(this.mapperTransactionState)
    this.nullifyPayloadInEdit = 'start';

    if (DOName === 'intimationDO' && resp && resp[DOName] && resp[DOName]['clmIntimationNum'])
      this.message.success(`Intimation(${resp[DOName]['clmIntimationNum']}) has been saved'`, { nzDuration: 4000 })

    if (DOName === 'claimDO' && resp && resp[DOName] && resp[DOName]['claimNum'])
      this.message.success(`Claim(${resp[DOName]['claimNum']}) has been saved'`, { nzDuration: 4000 })

    this._intimationTransformServerToUI(resp);
    this.payloadInEdit = this.commonUtilty.deepCopy(resp);
  }

  private _postSubmitHandler(resp: any) {
    this._transactionInProgress = false
    let DOName = this._getDOName(this.mapperTransactionState)
    this.nullifyPayloadInEdit = 'start';

    if (DOName === 'intimationDO' && resp && resp[DOName] && resp[DOName]['clmIntimationNum'])
      this.message.success(`Intimation(${resp[DOName]['clmIntimationNum']}) has been submitted'`, { nzDuration: 4000 })

    if (DOName === 'claimDO' && resp && resp[DOName] && resp[DOName]['claimNum'])
      this.message.success(`Claim(${resp[DOName]['claimNum']}) has been submitted'`, { nzDuration: 4000 })

    if (resp && resp.exceptionDOList.length <= 0) {
      this.router.navigate(['/app/claims/inbox/workbench'])
      //Separate Convert Call Removed from here.
    } else {
      this._intimationTransformServerToUI(resp);
      this.payloadInEdit = this.commonUtilty.deepCopy(resp);

    }

  }

  _extractSubmissionModeFromIO(payload) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      return payload[DOName]['intimationSourceCd']
    }

  }

  _setSubmissionModeFromUI(payload) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      payload[DOName]['intimationSourceCd'] = this._intimationSourceCd
    }
    return payload
  }

  _intimationTransformServerToUI(serverIO) {
    this._intimationSourceCd = this._extractSubmissionModeFromIO(serverIO)
    this._inputClaimsBasicDetailsComponent = this._ClaimsBasicDetailsServerDOToComponentMapper(serverIO)
    this._inputCapturedPolicyListComponent = this._CapturedPolicyListServerDOToComponentMapper(serverIO)
    this._inputAllClientListComponent = this._CapturedClientListServerDOToComponentMapper(serverIO)
    this._inputDocumentManagerComponent = this._DocumentManagerDOToComponentMapper(serverIO)
    this._inputClaimDecisionComponent = this._ClaimDecisionDOToComponentMapper(serverIO)
    this._inputClaimsBenefitComponent = this._ClaimsBenefitDOToComponentMapper(serverIO)
    this._inputMulticaptureBankDetailsComponent = this._MulticaptureBankDetailsToComponentMapper(serverIO)

    return this.getTransactionGuid(serverIO)
  }

  _ClaimsBasicDetailsComponentToSeverDOMapper(payload, response) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      payload[DOName].eventTypeCd = response.componentData.value.eventType;
      payload[DOName].eventDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.eventDate);
      payload[DOName].eventTm = this.commonUtilty.UIDOtoServerDOsetTime(response.componentData.value.eventTime);
      payload[DOName].causeOfDeathCd = response.componentData.value.causeOfDeath;
      payload[DOName].intimationDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.intimationDt);
      payload[DOName].receivedDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.receivedDt)
      if (!payload[DOName].entryDt)
        payload[DOName].entryDt = new Date();
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && !environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimsBasicDetailsComponent = {}
  _ClaimsBasicDetailsServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    var output = {}
    if (payload && DOName && payload[DOName]) {
      output['eventType'] = payload[DOName].eventTypeCd
      if (payload[DOName].eventDt)
        output['eventDate'] = payload[DOName].eventDt
      if (payload[DOName].eventTm)
        output['eventTime'] = payload[DOName].eventTm
      output['causeOfDeath'] = this._ClaimsBasicDetailsComponentToSeverDOBusinessLogic('DEATHEVENTTYPE', payload[DOName].causeOfDeathCd, output['eventType'])
      output['intimationDt'] = payload[DOName].intimationDt
      output['receivedDt'] = payload[DOName].receivedDt
    }
    return output
  }

  _ClaimsBasicDetailsComponentToSeverDOBusinessLogic(BLRULE, sourceData, caseData?) {
    if (BLRULE === 'DEATHEVENTTYPE') {
      if (caseData === 'DEATH' && sourceData != null) {
        return null
      }
    }
  }

  _CapturedPolicyListComponentToSeverDOMapper(payload, response) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && response && DOName && payload[DOName] && (payload[DOName]['policies'] || payload[DOName]['policy'])) {
      if (this.mapperTransactionState == 'claimIntimation') {
        payload[DOName]['policies'] = this.___markClaimLoggedFl(response.componentData)
      }
      else {
        payload[DOName]['policy'] = this.___markClaimLoggedFl(response.componentData)
      }
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputCapturedPolicyListComponent = {}
  _CapturedPolicyListServerDOToComponentMapper(payload) {
    var output = {}
    if (payload && payload['intimationDO'] && payload['intimationDO']['policies'])
      output = payload.intimationDO.policies

    if (payload && payload['claimDO'] && payload['claimDO']['policy'])
      output = payload.claimDO.policy

    if (payload && payload['investigationDO'] && payload['claimDO']['policy'])
      output = payload.investigationDO.policy

    return output
  }

  ___markClaimLoggedFl(data: Array<any>) {
    let output
    if (data && data.length && data.length > 0) {
      output = this.commonUtilty.deepCopy(data)
      output.forEach(policy => {
        policy['claimLoggedFl'] = true
      });
    }
    if (output)
      return output
    else
      return data
  }

  ___markAllRequirementsAsReceived(payload) {
    if (payload && payload['requirementDOs'] && payload['requirementDOs'].length > 0) {
      payload['requirementDOs'].forEach(requirement => {
        requirement['status'] = "RECEIVED"
      });
    }

    return payload
  }

  ___markAllChecklistAsCompleted(payload) {
    if (payload && payload['checkLists'] && payload['checkLists'].length > 0) {
      payload['checkLists'].forEach(checklistItem => {
        checklistItem['completedFl'] = true
      });
    }

    return payload
  }

  _CapturedClientListComponentToSeverDOMapper(payload, response): any {
    let orphanClientsRemoved = this._removeOrphanClient(payload)
    let outputAfterClientsRemoved = this._clientRoleRemoverToServerDO(orphanClientsRemoved, response)
    let output = this._clientRoleMapperToServerDO(outputAfterClientsRemoved, response)
    if (output && output.clientDOs && Array.isArray(output.clientDOs)) {
      output.clientDOs.forEach((client, index) => {
        if (!client) {
          output.clientDOs.splice(index, 1)
        }
      });
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(output)}`)
    }
    return output
  }

  _inputAllClientListComponent = {}
  _CapturedClientListServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    let output = {}
    let clientMap = {}
    if (payload && payload[DOName] && payload[DOName]['claimClientRoles']) {

      //Create Nodes for All the Roles
      payload[DOName].claimClientRoles.forEach(clientRole => {
        if (!output[clientRole.roleCd]) {
          output[clientRole.roleCd] = [clientRole.clientRefGuid]
        }
        else {
          output[clientRole.roleCd].push(clientRole.clientRefGuid)
        }

        // Extract Copy Scenario
        if (clientMap[clientRole.clientRefGuid]) {
          if (clientMap[clientRole.clientRefGuid] === "NOMINEE" && clientRole.roleCd === "CLAIMANT") {
            output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
          }
          if (clientMap[clientRole.clientRefGuid] === "CLAIMANT" && clientRole.roleCd === "NOMINEE") {
            output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
          }
        }
        clientMap[clientRole.clientRefGuid] = clientRole.roleCd
      })

      //Populate ClientList for Every Role
      for (const key in output) {
        if (output.hasOwnProperty(key)) {
          let clientRefGuidList = this.commonUtilty.deepCopy(output[key])
          output[key] = []
          if (clientRefGuidList && Array.isArray(clientRefGuidList) && payload.clientDOs) {
            clientRefGuidList.forEach(clientRef => {
              let client = payload.clientDOs.find(item => {
                if (item)
                  return item['guid'] === clientRef
              })
              if (client)
                output[key].push(client)
            })
          }
        }
      }

      //Extract PAYEES
      output = this._extratRefGuidsOfPayees(payload, output)
    }
    return output
  }

  _extratRefGuidsOfPayees(payload, output) {
    let listOfPayees = []
    let nodeName = 'claimPayments'
    let DOName = this._getDOName(this.TransactionState)
    if (payload && DOName && payload[DOName] && payload[DOName][nodeName] && payload[DOName][nodeName].length) {
      payload[DOName][nodeName].forEach(claimPayment => {
        if (claimPayment)
          listOfPayees.push(claimPayment.clientRefGuid)
      });
    }
    output['PAYEE'] = this.commonUtilty.deepCopy(listOfPayees)
    return output
  }

  _clientRoleMapperToServerDO(payload, response) {
    let role
    let output = this.commonUtilty.deepCopy(payload)
    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role
      let selectedClientData = response.componentData.clientList.selectedClientData
      let clientsToBeRemoved = []
      if (selectedClientData) {
        clientsToBeRemoved = selectedClientData.filter(client => client['remove'])
      }
      let fetchedClientData = response.componentData.clientList.fetchedClientData
      if (fetchedClientData != null && typeof fetchedClientData == typeof []) {
        fetchedClientData.forEach(item => {
          let isClientToBeRemoved = clientsToBeRemoved.findIndex(clientTobeRemove => {
            return clientTobeRemove['guid'] == item['guid']
          })
          if (isClientToBeRemoved == -1) {
            output = this._pushToClientDO(output, item);
            output = this._addClientRole(output, item, role, this.TransactionState)
          }
        })
      }
    }
    return output
  }

  _removeOrphanClient(payload, roleCd?) {
    //Functionality Pending

    return payload
  }

  _clientRoleRemoverToServerDO(payload, response) {
    let role
    let output = this.commonUtilty.deepCopy(payload)
    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role
      let selectedClientData = response.componentData.clientList.selectedClientData
      let clientsToBeRemoved = []
      if (selectedClientData) {
        clientsToBeRemoved = selectedClientData.filter(client => client['remove'])
      }
      let fetchedClientData = response.componentData.clientList.fetchedClientData
      if (fetchedClientData != null && typeof fetchedClientData == typeof []) {
        fetchedClientData.forEach(item => {
          let isClientToBeRemoved = clientsToBeRemoved.findIndex(clientTobeRemove => {
            return clientTobeRemove['guid'] == item['guid']
          })

          if (isClientToBeRemoved != -1) {
            output = this._removeClientRole(output, item, role, this.TransactionState);
            output = this._removeClientDO(output, item, this.TransactionState)
          }
        })
      }
    }
    return output
  }

  _removeClientRole(p, m, r, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = "claimClientRoles"
    let index
    if (p && p[DOName] && p[DOName][NodeName]) {
      index = p[DOName][NodeName].findIndex(x => {
        return x.clientRefGuid === m.guid && x.roleCd === r
      });

      if (index != -1) {
        p[DOName][NodeName].splice(index, 1)
      }
    }

    return p
  }

  _removeClientDO(p, m, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = "claimClientRoles"
    if (p && p.clientDOs && m && m.guid) {
      //Check if client has no other role existing only then delete clientDO
      let index = p.clientDOs.findIndex(x => { if (x && m) return x.guid === m.guid });
      if (index != -1) {
        if (p && p[DOName] && p[DOName][NodeName]) {
          //find the index of role, the clientDO currently has
          let roleIndex = p[DOName][NodeName].findIndex(x => {
            return x.clientRefGuid === m.guid
          });
          if (roleIndex === -1) // If -1 that means the specific clientDO has no active role in transaction
            p.clientDOs.splice(index, 1)
        }
      }
    }
    return p
  }

  _pushToClientDO(p, m) {
    if (p && p.clientDOs && m && m.guid) {
      let index = p.clientDOs.findIndex(x => { if (x && m) return x.guid === m.guid });
      if (index != -1)
        p.clientDOs.splice(index, 1, m)
      else {
        p.clientDOs.push(m)
      }
    }
    return p
  }

  _addClientRole(p, m, r, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = "claimClientRoles"
    let index
    if (p && p[DOName] && p[DOName][NodeName]) {
      index = p[DOName][NodeName].findIndex(x => {
        return x.clientRefGuid === m.guid && x.roleCd === r
      });

      if (index != -1) {
        let claimClientRoleItem = this.commonUtilty.deepCopy(p[DOName][NodeName][index])
        claimClientRoleItem.clientRefGuid = m.guid
        claimClientRoleItem.roleCd = r
        p[DOName][NodeName].splice(index, 1, claimClientRoleItem)
      }
      else {
        let claimClient = new ClaimClientRole(m.guid, r)
        if (!p[DOName][NodeName]) p[DOName][NodeName] = []
        p[DOName][NodeName].push(claimClient)
      }

      //Removing Orphan Claimants
      //TODO Owner Ninad: Remove Orphan claimants
      // if (!this.appMetadataHandler.isStable && r === "CLAIMANT" && this.appMetadataHandler.claimsModes.claimantMode === 'SINGLE') {
      //   let orphanCliamantsRemoved = p[DOName][NodeName].filter(claimRole => {return ((claimRole.clientRefGuid != m.guid )&& (claimRole.roleCd != "CLAIMANT"))})
      //   p[DOName][NodeName] = this.commonUtilty.deepCopy(orphanCliamantsRemoved)
      // }
    }

    return p
  }



  //differential
  _getDOName(state) {
    let output = configData.StateToDOMapper[state]
    let defaultClaimDOFeatureOnAndNoDOFoundInMapper = this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !configData.StateToDOMapper[state]
    let defaultClaimDOFeatureOffAndNoDOFoundInMapper = !this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !configData.StateToDOMapper[state]
    if (defaultClaimDOFeatureOnAndNoDOFoundInMapper) {
      return 'claimDO'
    }
    else if (defaultClaimDOFeatureOffAndNoDOFoundInMapper)
      throw "No Valid DO name for the state passed --" + state;
    else
      return output

  }

  _DocumentManagerComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      if (payload[DO]['requirementDOs']) {
        payload[DO]['requirementDOs'] = this.commonUtilty.deepCopy(response.componentData.requirementDOs)
      }
      if (payload[DO]['entityDocumentDOs']) {
        payload[DO]['entityDocumentDOs'] = this.commonUtilty.deepCopy(response.componentData.entityDocumentDOs)
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }

    return payload
  }

  _inputDocumentManagerComponent = {};
  _DocumentManagerDOToComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState);
    let output = {
      'requirementDOs': null,
      'entityDocumentDOs': null
    };
    if (payload) {
      /* Requirements*/
      if (payload['requirementDOs']) output['requirementDOs'] = payload['requirementDOs'];
      /* Docs */
      if (payload['entityDocumentDOs']) output['entityDocumentDOs'] = payload['entityDocumentDOs'];
    }
    return payload;//output;
  }

  _ClaimDecisionComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['adjDecisionCd'] = response.componentData.value.claimDecision
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimDecisionComponent = {};
  _ClaimDecisionDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _ClaimsBenefitComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['claimCoverages'] = response.componentData
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimsBenefitComponent = {};
  _ClaimsBenefitDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _MulticaptureBankDetailsComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      // payload[DO]['claimPayments'] = response.componentData
      response.componentData.forEach(receivedPaymentDetails => {
        let foundIndex = payload[DO]['claimPayments'].findIndex(claimPayment => claimPayment.clientRefGuid == receivedPaymentDetails.clientRefGuid)
        if (foundIndex == -1) {
          payload[DO]['claimPayments'].push(receivedPaymentDetails)
        }
        else {
          for (const key in receivedPaymentDetails) {
            if (receivedPaymentDetails.hasOwnProperty(key) && receivedPaymentDetails[key]) {
              payload[DO]['claimPayments'][foundIndex][key] = receivedPaymentDetails[key]
            }
          }
        }
      });
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputMulticaptureBankDetailsComponent = [];
  _MulticaptureBankDetailsToComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState)
    let output = [];
    if (payload && payload[DO] && payload[DO]['claimPayments']) {
      output = this.commonUtilty.deepCopy(payload[DO]['claimPayments'])
    }
    return output;
  }


  getTransactionGuid(serverIO) {
    let DOName = this._getDOName(this.TransactionState)
    if (serverIO && DOName && serverIO[DOName])
      return serverIO[DOName]['guid'] || null
    else
      return null
  }


  NullValue: any = null;
  ClientCaptureFooter = null;

  tabs: any[] = [];
  nzTabPosition = 'top';
  selectedIndex = 0;
  nomineeDataSet: any[] = [];
  MULTI: any = "MULTI";
  SINGLE: any = "SINGLE";
  claimantDataSet: any[] = [];
  // policyDataSet:any[] =[];
  parentPolicyItem: any[] = [];
  policyListFetchedFromServer: any[] = [];
  enableCopyOfClaimantAsNominee = true;
  transactionGuid = null
  _intimationSourceCd = null

  showLastNote: boolean = true;

  /* tslint:disable-next-line:no-any */
  log(args: any[]): void {
    console.log(args);
  }

  ngOnInit(): void {
    // this.tabs = [
    //   { name: "Claimant Details" },
    //   { name: "Bank Details" },
    //   { name: "Life Insured" },
    //   { name: "Hospital Details" },
    //   { name: "Decision" },
    // ]

    this.interactService.transactionSubject$.pipe(take(1)).subscribe(res => {
      this.TransactionState = res.state
      this.transactionMasterUpdateControl = configData.inboxTypeToUpdateControlMapper[res.inboxType]
      this.mapperTransactionState = res.state
      this.nullifyPayloadInEdit = 'start'
      this._intimationSourceCd = res.intimationSourceCd
      if (res.IO && res.IO != undefined)
        this.payloadInEdit = this.commonUtilty.deepCopy(res.IO);
      this.tempJosn = res.IO;
      if (res.taskId)
        this.taskId = res.taskId

      console.log("temp json ", this.tempJosn);
      this.initializeChildSubscribers()
      if (res.IO != null)
        this.transactionGuid = this._intimationTransformServerToUI(res.IO);
    });

    this.refreshClaimantList();
    this.setDefaultStatePermissionVars();
  }

  ngAfterViewInit() {
    this.initializeIntimationTabs()
  }

  /* Variables */
  dataSet = [{}, {}];

  showConfirm(toStage: string): void {
    this.modalService.confirm({
      nzTitle: `<i>Are you sure you want to reverse to ${toStage}?</i>`,
      nzContent: '<b>This action cannot be undone!</b>',
      nzOkText: "Reverse",
      nzOnOk: () => console.log('OK')
    });
  }

  /* Police Station Details */
  hasPoliceStnDetails: boolean = true;

  /* Nominee Same as Claimant ? */
  // claimantSameAsNominee: boolean = true;
  private _claimantSameAsNominee: any;
  set claimantSameAsNominee(value: boolean) {

    if (value !== null) {
      this._claimantSameAsNominee = value;
    }
    else
      this._claimantSameAsNominee = false

    this.triggerClaimantSameAsNomineeChanges()
  }
  get claimantSameAsNominee(): boolean {
    return this._claimantSameAsNominee;
  }

  triggerClaimantSameAsNomineeChanges() {
    if (this._claimantSameAsNominee)
      this.setClaimantAsNominee()
    else
      this.claimantDataSet = [];
  }
  setClaimantAsNominee() {
    this.claimantDataSet = [];
    this.claimantDataSet = this.nomineeDataSet;
  }

  /* PANELS */

  notesPanelOpen = false;
  notesPanel(status) { this.notesPanelOpen = !!status }

  policyPanelOpen = false;
  policyPanel(status) { this.policyPanelOpen = !!status }

  profilePanelOpen = false;
  profilePanel(status) { this.profilePanelOpen = !!status }

  corresPanelOpen = false;
  corresPanel(status) { this.corresPanelOpen = !!status }

  docuPanelOpen = false;
  docuPanel(status) { this.docuPanelOpen = !!status }

  documentManagerHandler(data) {
    this.docuPanel(data)
  }

  worksheetPanelOpen = false;
  worksheetPanel(status) { this.worksheetPanelOpen = !!status }

  workflowPanelOpen = false;
  showDropdown = false;
  workflowPanel(status, showDropdown = false) {
    this.showDropdown = showDropdown;
    this.workflowPanelOpen = !!status;
  }

  pendingPanelOpen = false;
  pendingPanel(status) { this.pendingPanelOpen = !!status }

  /* Investigator modal */
  modInvtgVis: boolean = false;

  note: string = '';
  noteCannedReply(indx: number) {
    switch (indx) {
      case 0: this.note = 'Please have a look at the ';
        break;
      case 1: this.note = 'Requesting additional investigation for ';
        break;
      case 2: this.note = 'Required Documents are not in place. Kindly do a through verification for ';
        break;
    }

  }



  /* Star */
  isStarred: boolean = false;
  /* Demo case --- only "adding" is shown */
  starThis() {
    this.message.loading('Adding to starred items', { nzDuration: 1200 });
    setTimeout(() => {
      this.message.success('#CLM0000107 added to you starred items', { nzDuration: 1200 });
      this.isStarred = true;
    }, 1200);
  }


  /* Rich Text Editor */
  modalCorrespNew: boolean = false;
  openCorrModal() {
    this.modalCorrespNew = true;
    this.corresPanel(0); //Close corresp panel (z index error fix)
  }
  correspondenceRichText: any = `
  <h3>Information regarding your clam  #CLM0000107<h3>
  <p>Dear %claimant_name%,</p>
  <br>
  <p>We request you to submit the death certificate for %lifeassured_name% at your earliest convenience.</p>
  <p>This would help us process your claim </p>
  <br>
  <p>Thank you,</p><br>
  <p>Team StandardLife</p>
  `;
  handleFileUpload(data) {
    console.log(data);
  }

  correspType: string = "email";
  modSubmit: boolean = false;

  defaultUploadsList: any = [
    {
      uid: 1,
      name: 'CERTI1.pdf',
      status: 'done',
      url: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456',
      thumbUrl: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456'
    },
    {
      uid: 2,
      name: 'DOC45.pdf',
      status: 'done',
      url: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg',
      thumbUrl: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg'
    }
  ];

  uploadArray = [{}];
  addUploadRow() {
    let objPush = {};
    this.uploadArray.push(objPush)
  }
  removeUploadRow() {
    this.uploadArray.pop();
  }


  /* Bank Details */
  bank: any = {};

  fetchFromIFSC() {
    this.bank = {};
    this.message.loading('Fetching Bank Details ...', { nzDuration: 1200 });
    setTimeout(() => {
      this.bank = {
        bankName: "ICICI BANK LTD.",
        branchName: "MUMBAI - FORT",
        micr: "400229016",
        city: "MUMBAI",
        address: "NAVSARI BUILDING, 240, D.N.ROAD, FORT, MUMBAI. 400001"
      }
    }, 1200);
  }

  /* Bank CHEQUE Upload */
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  fileList = [{
    uid: 1,
    name: 'xxx.png',
    status: 'done',
    url: "https://bse2nse.com/images/cancelled_cheque.png"
  }];
  previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };

  /* Event Type */
  // eventType: string = "Death";


  /* Search by Customer or Policy */
  searchCustOrPolicy: string = "customer";
  searchCustOrPolicyLoading: boolean = false;
  searchCustOrPolicyChanged() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
  }
  searchAddCustomer = 'search-customer';
  modSearchCustOrPolicy: boolean = false;

  showCustomerPolicies: boolean = false;
  showCustomerPoliciesName: string = '';
  viewAddCustomersPolicies(namePassed) {
    this.showCustomerPolicies = true;
    this.showCustomerPoliciesName = namePassed;
  }

  modSearchCustomer: boolean = false;
  modSearchCustomerClaimant: boolean = false;

  searchPolicyClientOk() {
    this.modSearchCustOrPolicy = false
  }

  /* Modals for Hospital and Doctor */
  modHospDetails: boolean = false;
  modDocDetails: boolean = false;
  modRejectIntimation: boolean = false;


  /* ERRORS ==== */
  hasErrors: boolean = false;
  setErrorState(state: boolean) {
    if (state) {
      this.message.loading('Saving', { nzDuration: 1000 });
      setTimeout(() => {
        this.message.error('Form has errors. Please fix to continue', { nzDuration: 3000 });
        this.hasErrors = state;
        this.fakeValidationStatus = 'error';
      }, 1000);
    }
    else {
      this.hasErrors = state;
      this.fakeValidationStatus = null;
    }
  }
  /* Error Panel */
  errPanelOpen: boolean = false;
  errPanelCollapsed: boolean = false;
  errDetailsPanel(state) { this.errPanelOpen = !!state }
  errorPanelToggle() {
    //Expand/collapse visible error panel
    this.errPanelCollapsed = !this.errPanelCollapsed;
  }

  /* Jump To Tab, Highlight field */
  fakeValidationStatus: any = null;
  errJumpTo(tabIndex: number, fieldToHighlight: string) {
    /* Auto-close panel ?*/
    this.errPanelOpen = false;
    /* Process */
    setTimeout(() => {
      /* Switch Tab */
      this.selectedIndex = tabIndex;
    }, 250);
    setTimeout(() => {
      /* Focus on Field */
    }, 500);
  }

  intimationDummyRequest = null
  copySourceForClaimant: ClientList = { selectedClientData: [], fetchedClientData: [] }
  updateClientList(data, clientType) {

    if (clientType === 'NOMINEE') {
      this.nomineeDataSet = data;
      this.interactService.sendNomineeListToBankDetails(data);
      // if (!this.nomineeClaimantFlag)
      //   this.claimantDataSet = data;
    }
    else
      this.copySourceForClaimant = data;
  }

  _EmittedClientHandler(data, targetRole) {
    if (data && targetRole === 'CLAIMANT') {
      this.copySourceForClaimant = data['clientList']
    }
  }

  updatePolicyList(data) {
    if (data && data.length === 1)
      this.parentPolicyItem = data[0];
    else
      this.policyListFetchedFromServer = data
  }


  getNominee(data) {
    this.nomineeDataSet = data.componentData;
    this.closeNomineeModal();

  }

  getPolicyList(data) {

    if (data && data.length === 1)
      this.parentPolicyItem = data[0];
    else
      this.policyListFetchedFromServer = data

  }

  closeNomineeModal() {
    this.modSearchCustomer = false;
  }

  getClaimant(data) {
    this.claimantDataSet = data.componentData;
    // this.updateClientList(this.claimantDataSet,"Claimant");
    this.closeClaimantModal();

  }

  closeClaimantModal() {
    this.modSearchCustomerClaimant = false;
  }

  pingChildToGetData() {
    this.interactService.pingChildToReact(this.route.routeConfig.component.name);
  }

  pingToClientSearchForNominee() {
    this.pingChildToGetData();
    this.modSearchCustomerClaimant = false;
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {

      dateString = moment(rawDate).format('DD MMM YYYY');
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  removeNominee(data, list, uniqueID) {
    this.nomineeDataSet = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
  }

  removeClaimant(data, list, uniqueID, index) {
    this.claimantDataSet = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
    this.interactService.removeClient('CLAIMANT', data, index, list)
  }

  pingToClientSearchForClaimant() {
    this.pingChildToGetData();
    this.modSearchCustomer = false;
  }


  metaDataArray = [
    {
      "key": "proposalNum",
      "description": "Proposal Number",
      "isVisible": true
    },
    {
      "key": "clmIntimationNum",
      "description": "Claim Number",
      "isVisible": true
    },
    {
      "key": "commencementDt",
      "description": "Policy Commencement",
      "isVisible": true
    },
    {
      "key": "Insured",
      "description": "Insured Name",
      "isVisible": true,
    },
    {
      "key": "claimedAmt",
      "description": "Claimed Amount",
      "isVisible": true,
    }
  ];

  refreshClaimantList() {
    this.interactService.claimantAsNomineeFlagSubject$.subscribe(flag => {
      this.nomineeClaimantFlag = flag;
    })
  }



  // for static data content
  permissions: any = [];
  showLastComment: boolean = false;
  modHospitalizationDetails: boolean = false;
  modSearchAddHosp: boolean = false;
  modSearchAddDoctor: boolean = false;
  tempBenefit1: string = `250000`;
  tempBenefit2: string = `20000`;
  tempBenefit3: string = `350000`;
  tempBenefitTotal: string = `150000`;

  /* Hospital Tabs: Hide/Show */
  tabHosp: any = "search-hosp";
  /* Doctor Tabs: Hide/Show */
  tabDoc: any = "search-doc";

  setDefaultStatePermissionVars() {
    this.permissions = {
      basic: { show: true, edit: true },
      insured: { show: true, edit: true },
      nominee_claimant: { show: true, edit: true },
      hospitalization: { show: true, edit: true },
      bank_details: { show: true, edit: true },
      benefit: { show: true, edit: true },
      payment_breakup: { show: true, edit: true },
      payout_details: { show: true, edit: true },
      adj_claim_decision: { show: true, edit: true },
      investigation_report: { show: true, edit: true },
      other_policies: { show: true, edit: true },
      analytics: { show: true, edit: true },
    };
    /* Set other defaults */
    this.showLastComment = true;
  }

  reffrelUserType: any = null;
  modalTitle: any = null;
  referOrSubmitMode(roleUserType) {
    if (roleUserType == 'INVESTIGATOR') {
      this.modalTitle = "Assign Investigator"
    } else {
      this.modalTitle = "Refer Task"

    }
    this.reffrelUserType = roleUserType
    this.interactService.referToRoleUserType(roleUserType)
    this.modInvtgVis = true;

  }
  refertoUser() {
    if (this.taskId && this.assigneeUser) {
      this.interactService.referToRoleUserType$.pipe(take(1))
        .subscribe(o => {
          let value = this.ReferMap[o]
          let DOName = this._getDOName(this.mapperTransactionState)
          let taskIO: TaskIO = new TaskIO()
          taskIO.assignedto = this.assigneeUser
          taskIO.taskCd = value;
          taskIO.objectName = 'ClaimDO'
          taskIO.entityGuid = this.payloadInEdit[DOName].guid
          this.workqueueService.createTask(taskIO).subscribe(resp => {
            this.modInvtgVis = false;

          });
        })

    }
  }

  ReferMap = {
    INVESTIGATOR: "claimInvestigtion",
    UNDERWRITER: "claimUWReferral",
    REINSURER: "claimReinsReferral",
  }
  //For Refer Modal


  /* Rules */
  //rulesData = rulesDataObj;

}
